import { render } from "./Stars.vue?vue&type=template&id=6fcd97e1"
const script = {}

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Stars.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fcd97e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fcd97e1', __exports__)) {
    console.log('reload')
    api.reload('6fcd97e1', __exports__)
  }
  
  module.hot.accept("./Stars.vue?vue&type=template&id=6fcd97e1", () => {
    console.log('re-render')
    api.rerender('6fcd97e1', render)
  })

}


export default __exports__